
export default {
  props: {
    area: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      menu: [
        {
          text: 'Home',
          disabled: !1,
          to: '/'
        },
        {
          text: 'Áreas de Atuação',
          disabled: !0,
          to: '/areas'
        }
      ],
      title: 'Conheça nossas principais áreas de atuação'
    }
  },
  computed: {
    site() {
      return site
    },
    height() {
      let size = 150,
        { xs, sm, mdAndUp } = this.$vuetify.breakpoint
      if (xs) size = 150
      else if (sm) size = 170
      else if (mdAndUp) size = 250
      return size
    }
  },
  created() {
    this.url = window.location.href
    if (this.area) {
      const { city, state } = this.site
      this.title = this.area + ' em ' + city + '-' + state
      this.menu[1].disabled = !1
      this.menu.push({
        text: this.area,
        disabled: !0,
        to: '/tratamentos'
      })
    }
  }
}
